import BoxInfo from '@/components/boxInfo/boxInfo';
import { ButtonClipBoard } from '@/components/buttonClipBoard/buttonClipBoard';
import React from 'react';
import { renderToString } from 'react-dom/server';
import { Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface ShareAreaProps {
  usageStatementId?: string;
}

export const ShareArea: React.FC<ShareAreaProps> = ({ usageStatementId }) => {
  const contentToCopay = (
    <div>
      <div>
        Olá, Time!
        <br />
        Segue o link para rotulação dos procedimentos:&nbsp;
        <a
          href={`${location.origin}/copaies/${usageStatementId}/details`}
          target='_blank'
          rel='noreferrer noopener'>
          link portal do RH
        </a>
      </div>
      <br />
      <div>
        <b>Importante:</b> todas as colunas devem ser preenchidas — nenhuma pode ficar em branco.
      </div>
      <br />
      <ul style={{ padding: '0 0 0 24px' }}>
        <li>Se não houver rótulo N2, preencher com OUTROS</li>
        <li>Preencher Flag Pacote com TRUE ou FALSE</li>
        <li>Preencher Flag HomeCare com TRUE ou FALSE</li>
        <li>Preencher Agrupa Taxa com TRUE ou FALSE</li>
      </ul>
    </div>
  );

  return (
    <BoxInfo margin='0' elevation={0} maxWidth={500}>
      <Grid column gap={33}>
        <Text value='Envie esta mensagem para o Time de Saúde:' title />
        {contentToCopay}
        <Grid alignContent='right' stretch>
          <ButtonClipBoard text={renderToString(contentToCopay)} size={40} />
        </Grid>
      </Grid>
    </BoxInfo>
  );
};
